var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"organization-tooltip-content"},_vm._l((_vm.organizations),function(organization,index){return _c('p',{key:index},[_vm._v(" "+_vm._s(organization)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }